import { StationInfo } from "@/entities/app-state/StationInfo";
import { LineDetails } from "@/entities/monitor/LineDetails";

export function isStationInfo(item: LineDetails | StationInfo): item is StationInfo {
  return item != null && Object.prototype.hasOwnProperty.call(item, "id");
}
